import { useRequest, useAuth } from "@onefront/react-sdk";
import { useCurrentTenant } from "@drift/oneplatfront";
import { generateHeaders } from "../../../utils/generate-headers";

interface IFetchConfig {
    params?: any;
    headers?: any;
    url: string;
}

interface IuseDelete {
    (workspaceId?: string, lazy?: boolean, data?: any): {
        loading?: boolean;
        fetch: (fetchConfig: IFetchConfig) => Promise<any>;
        error: boolean;
    };
}

export const useDelete: IuseDelete = (workspaceId, lazy = true) => {
    const { tenant } = useCurrentTenant(true);
    return useRequest({
        method: "delete",
        headers: generateHeaders(useAuth(), tenant?.itemId, workspaceId),
        url: ``,
        lazy
    });
};
